<template>
  <div class="retail-header h-full">
    <div class="place-self-start self-center xl:place-self-center">
      <div
        v-if="merchantStore.siteConfig?.title"
        aria-label="Site Title"
        class="font-semibold xl:text-xl"
      >
        {{ merchantStore.siteConfig.title }}
      </div>

      <MerchantLogo v-else class="size-full xl:place-self-center" />
    </div>

    <div class="hidden place-self-center xl:block">
      <UIStepper v-show="showStepper" :steps="steps" />
    </div>

    <div class="place-self-end">
      <FlowExitButton class="xl:hidden" @exit="exit" />
    </div>
  </div>
</template>

<script setup lang="ts">
  import UIStepper from "@ui-kit/components/stepper"
  import { FlowExitButton } from "@versatile-credit-apply/components/session"
  import { computed } from "vue"
  import { useRoute } from "vue-router"

  import MerchantLogo from "./MerchantLogo.vue"
  import { useStepperSteps } from "@/composition/use-stepper-steps"
  import { useI18n } from "vue-i18n"
  import { useExitFlow } from "@/composition"
  import { useMerchantStore } from "@versatile-credit-apply/sdk"

  const steps = useStepperSteps(useI18n())

  const exitFlow = useExitFlow()
  const exit = () => exitFlow("canceled")

  const route = useRoute()
  const showStepper = computed(() => route?.meta?.stepper?.visible !== false)

  const merchantStore = useMerchantStore()
</script>

<style lang="css" scoped>
  @reference "@/main.css";

  .retail-header {
    display: grid;
    grid-template-columns: 2fr 1fr;
    grid-template-rows: max-content;
  }

  @variant xl {
    .retail-header {
      grid-template-columns: 1fr;
      grid-template-rows: 1fr 3fr 1fr;
    }
  }
</style>

<i18n lang="yaml" locale="en">
stepper:
  steps:
    applicant:
      label: Applicant Info
    decision:
      label: Decision
    link-sent:
      label: Link Sent
    reviewOffer:
      label: Review Offer
    terms:
      label: >
        Terms & Conditions
</i18n>
